import { render, staticRenderFns } from "./communicate.vue?vue&type=template&id=0bd7f6ee&scoped=true&"
import script from "./communicate.vue?vue&type=script&lang=js&"
export * from "./communicate.vue?vue&type=script&lang=js&"
import style0 from "./communicate.vue?vue&type=style&index=0&id=0bd7f6ee&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bd7f6ee",
  null
  
)

export default component.exports